import { EMAIL_VALIDATOR, PHONE_VALIDATOR } from "helpers/validators";

const pickerFormFields = {
  FullName: {
    fieldKey: "FullName",
    element: "input",
    type: "text",
    placeholder: "full-name",
    validation: {
      required: true,
    },
  },

  Email: {
    fieldKey: "Email",
    element: "input",
    type: "email",
    placeholder: "signin-email-placeholder",
    validation: {
      required: true,
      invalidMessage: "invalid-email-text",
      reg: EMAIL_VALIDATOR,
    },
  },

  Phone: {
    fieldKey: "ContactPhone",
    element: "input",
    type: "tel",
    title: "ContactPhone",
    label: "contact-us-phone",
    placeholder: "contact-us-phone",
    validation: {
      required: true,
      reg: PHONE_VALIDATOR,
      invalidMessage: "phone-error-message",
    },
  },
};

export default pickerFormFields;
